export const VOICE_NOTE_CAPABILITY_ATTRIBUTE = "chickytutor.voiceNotes";
export const VOICE_NOTE_CAPABILITY_VERSION = "buffered-v1";
export const VOICE_NOTE_PRONUNCIATION_CAPABILITY_ATTRIBUTE = "chickytutor.pronunciationAnalysis";
export const VOICE_NOTE_PRONUNCIATION_CAPABILITY_VERSION = "available-v1";

export function supportsBufferedVoiceNotes(
  attributes: Readonly<Record<string, string>> | undefined
): boolean {
  return attributes?.[VOICE_NOTE_CAPABILITY_ATTRIBUTE] === VOICE_NOTE_CAPABILITY_VERSION;
}

export function supportsVoiceNotePronunciationAnalysis(
  attributes: Readonly<Record<string, string>> | undefined
): boolean {
  return (
    attributes?.[VOICE_NOTE_PRONUNCIATION_CAPABILITY_ATTRIBUTE] ===
    VOICE_NOTE_PRONUNCIATION_CAPABILITY_VERSION
  );
}
